const STORAGE_KEY = 'sf_remember_profile';
const SAVED_PROFILE_VERSION = 1;

export type LastProvider = 'google' | 'password';

export interface SavedProfile {
  v: number;
  uid: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
  lastProvider: LastProvider;
  savedAt: number;
}

export function readSavedProfile(): SavedProfile | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SavedProfile>;
    if (parsed.v !== SAVED_PROFILE_VERSION) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    if (
      typeof parsed.uid !== 'string' ||
      typeof parsed.email !== 'string' ||
      (parsed.lastProvider !== 'google' && parsed.lastProvider !== 'password')
    ) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed as SavedProfile;
  } catch {
    try { localStorage.removeItem(STORAGE_KEY); } catch { /* noop */ }
    return null;
  }
}

export function writeSavedProfile(p: Omit<SavedProfile, 'v' | 'savedAt'>): void {
  try {
    const record: SavedProfile = { ...p, v: SAVED_PROFILE_VERSION, savedAt: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    /* quota or disabled storage — silently ignore */
  }
}

export function clearSavedProfile(): void {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* noop */ }
}
